import { createFileRoute, Outlet } from '@tanstack/react-router';
import { requireMenuOrRedirect } from '@/lib/auth/require-permission';

export const Route = createFileRoute('/_app/ads/accounts')({
  beforeLoad: requireMenuOrRedirect('menu:ads-admin:ad-accounts', '/ads/dashboard'),
  component: () => <Outlet />,
});
